export default "__VITE_ASSET__rP5Fqrti__"